import API from "../../Data/Domain/API";
import URL from "../../Data/Domain/URL";
import Storage from "../../Data/Domain/Storage";

export async function getSuppliers(params) {
  return await new API(URL.setParams(URL.buildUrl("suppliers"), params)).get();
}
export async function postSuppliers({ name }) {
  return await new API(URL.buildUrl("suppliers")).post({ name });
}
export async function getSuppliersByUser(id) {
  const internal_id = id || new Storage("id").getItem();
  const year = new Storage("offsetYear").getItem();

  let endpoint = `users/${internal_id}/suppliers`;

  if (year) {
    endpoint += `?year=${year}`;
  }

  return await new API(URL.buildUrl(endpoint)).get();
}

export async function putSuppliers(id, data) {
  const url = URL.setId(URL.buildUrl("suppliers"), id);
  return await new API(url).put(data);
}

export async function deleteSupplier(id) {
  return await new API(URL.setId(URL.buildUrl("suppliers"), id)).delete();
}

export async function getSubcategoriesBySuppliersAndUser(id) {
  const id_user = new Storage("id").getItem();
  const year = new Storage("offsetYear").getItem() || new Date().getFullYear();

  let url = URL.buildUrl(`users/${id_user}/subcategories/${id}/suppliers`);
  if (year) {
    url = URL.setQuery(url, { key: "year", value: year });
  }

  return await new API(url).get();
}
